import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditZoneComp from '../../components/version-4/MasterForms/EditForms/EditZoneComp'
import { useZone } from '../../hooks/CompanyConfiguration/useZone'
import { ROUTES } from '../../shared/constants'
function EditZone() {
  const { zone, getZone, updateZone } = useZone()
  const params = useParams()
  const [zonedata, setZoneData] = useState({
    name: '',
    region: '',
    zoneCode: '',
    active: '',
  })

  React.useEffect(() => {
    getZone({ zoneId: params.zoneId })
  }, [params.zoneId])

  React.useEffect(() => {
    if (zone) {
      setZoneData({
        name: zone.name,
        region: zone.region._id,
        zoneCode: zone.zoneCode,
        active: zone.active,
      })
    }
  }, [zone])

  //console.log('ZONE DATA :', zonedata)

  const handleZone = () => {
    updateZone({
      zoneId: params.zoneId,
      name: zonedata.name,
      region: zonedata.region,
      zoneCode: zonedata.zoneCode,
      active: zonedata.active,
    })
  }
  return (
    <Layout heading="Zone" heading2="Edit" url1={ROUTES.ZONE} none>
      {zone ? <HeaderTabLayout heading="Edit Zone" state={zonedata} setState={setZoneData}  content={<EditZoneComp state={zonedata} setState={setZoneData} />} addContent={handleZone} redirect={ROUTES.ZONE} /> : <Loader />}
    </Layout>
  )
}

export default EditZone
